// for-sale and to-rent search
import { NextRouter } from 'next/router';
import { Dispatch } from 'react';
import { SearchPageType, SearchSource } from '@zoopla/listing-search-context';
import { updateResults } from '@zoopla/listing-search-update-results';

export const searchProperties = (
    userAlertId: string | null,
    router: NextRouter,
    // eslint-disable-next-line
    dispatch: Dispatch<any>,
    searchType: SearchPageType,
    searchSource: SearchSource,
    // eslint-disable-next-line
    filters: any,
    sortOrder: string,
    excludeRadius?: boolean,
    excludePageSize?: boolean
) => {
    if (userAlertId) {
        dispatch({
            type: 'SET_PREVIOUS_SAVED_SEARCH_URI',
            payload: router.asPath
        });
    }

    dispatch({ type: 'SET_SEARCH_SOURCE', payload: searchSource });

    if (userAlertId) {
        dispatch({
            type: 'SET_IS_EDIT_SAVED_SEARCH_BANNER_VISIBLE',
            payload: true
        });
        dispatch({
            type: 'SET_IS_EDIT_SAVED_SEARCH_SUCCESS',
            payload: null
        });
    }

    const ignoreLocationText = false;
    const page = 1;
    updateResults(
        filters,
        router,
        searchType as SearchPageType,
        searchSource,
        sortOrder,
        userAlertId,
        excludeRadius,
        ignoreLocationText,
        page,
        excludePageSize
    );
};
